module.exports = __webpack_public_path__ + "2dd494303ae1075456fa3df6ddc68ef0.svg";